const initialState = {
  open: true,
};

const blackFridayModalPopup = (state = initialState, action) => {
  switch (action.type) {
    case 'blackFriday':
      return { ...state, open: action.value };
    default:
      return state;
  }
};

export { blackFridayModalPopup };
